<template>
  <div class="end">
    <TopHeader v-if="!webView" @clickMinimize="closeWindow"/>
    <div class="thank-you">
      <Icon art="light" color="var(--tw-c-dark-green-blue)" name="heart" :width="52" :height="52" />
      <h1 v-if="!webView">
        {{ t('end_title') }}
      </h1>
      <h1 v-if="webView">
        {{ split1(t('end_title')) }}
        <span class="alt-color">
          {{ split2(t('end_title')) }}
        </span>
      </h1>
      <p class="intro">
        {{ t('end_messages_intro') }}
      </p>
    </div>
    <div class="feedback">
      <h3>
        {{ t('tnps_feedback_title') }}
      </h3>
      <p>
        {{ t('tnps_feedback_text') }}
      </p>
      <button class="link" @click="setShowTNPSModal(true)">
        <Icon
          class="icon"
          art="regular"
          name="long-arrow-right"
          color="var(--tw-c-original-green)"
          :width="20"
          :height="20"
        />
        {{ t('tnps_feedback_button') }}
      </button>
    </div>
    <div style="flex:1"></div>
    <div class="buttons">
      <h3>
        {{ t('tnps_feedback_next_title') }}
      </h3>
      <ChatButton
        :types="['secondary']"
        class="button"
        @click="restartChat"
        :label="t('end_buttons_restart')"
      />
      <ChatButton
        :types="['primary']"
        class="button"
        @click="closeWindow"
        :label="t('tnps_button_close')"
      />
    </div>
  </div>
</template>

<script>
import ChatButton from './ChatButton'
import TopHeader from './TopHeader'
import Icon from './Icon'
import { mapGetters, mapActions } from 'vuex'
import { trigger, triggerType } from '@/helpers/Tracker'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { EVENT, dispatchCustomEvent } from '@/helpers/customEvents'

export default {
  name: 'EndWithTNPS',

  components: {
    TopHeader,
    ChatButton,
    Icon
  },

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  computed: {
    ...mapGetters('uistate', ['getBehavior', 'webView', 'isCustomerFlow']),
  },

  methods: {
    ...mapActions('uistate', ['setShowTNPSModal']),

    async closeWindow (isRestart = false) {
      await this.$store.dispatch('uistate/clearAiaiBotDisclaimer')
      await this.$store.dispatch('conversation/conversationClose')

      trigger(triggerType.ACTION, 'ChatBoxClosed')

      if (this.webView) {
        window.location.href += '?ChatBoxClosed=true'
      } else {
        if (this.getBehavior === 'passive' && !isRestart) {
          dispatchCustomEvent(EVENT.SEND.CLOSE)
        }
        this.$emit('close')
      }
      sessionStorage.behavior = ''
    },
    async restartChat () {
      if (!this.webView) {
        await this.$store.dispatch('uistate/clearAiaiBotDisclaimer')
        await this.closeWindow(true)
        setTimeout(() => dispatchCustomEvent(EVENT.LISTEN_TO.OPEN), 500)
      }
      await this.$store.dispatch('conversation/setArchived')
      if (this.webView) {
        location.reload()
      }
    },
    split1 (input) {
      if (input.split(' ', 2).length === 2) {
        return input.split(' ', 2)[0] + ' '
      } else if (input.split(/\b/).length === 2) {
        return input.split(/\b/)[0]
      } else {
        return input
      }
    },
    split2 (input) {
      if (input.split(' ', 2).length === 2) {
        return input.split(' ', 2)[1] + ' '
      } else if (input.split(/\b/).length === 2) {
        return input.split(/\b/)[1]
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.end {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  border-radius: 0;
  box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12);
  z-index: 3;

  p {
    color: var(--tw-c-black);
  }
}

.thank-you {
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  background: var(--tw-c-dark-green-lighten-12);
}

h1 {
  font-family: 'TheMix Bold', sans-serif;
  font-size: 25px;
}

.intro {
  text-align: center;
}

h3 {
  margin: 0 0 4px;
}

.feedback,
.buttons {
  padding: 0 8px;
}

.feedback {
  padding-top: 24px;
}

.link {
  padding: 8px 0;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 900;
  color: var(--tw-c-original-green);
  border: none;
  background: transparent;
  cursor: pointer;

  .icon {
    margin: 1px 8px 0 0;
  }
}

.buttons {
  display: flex;
  flex-direction: column;
}

.button {
  height: 50px;
  border-radius: 25px;
}
</style>
